import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from "kea-resource";

const controller = rpcController("DireccionCliente");
const crud = rpcCrudService<models.DireccionCliente, models.DireccionClienteDTO>(controller);

import { Cliente } from "./cliente";


export const DireccionCliente = cacheResource({

    ...crud,
    /** Obtiene un listado de direcciones de cliente */
    ObtenerDireccionesCliente: async (idCliente: number): Promise<models.DireccionClienteDTO[]> => await controller("ObtenerDireccionesCliente", { idCliente }),
    ObtenerDireccion: async (idDireccion: number): Promise<models.DireccionCliente> => await controller("ObtenerDireccion", { idDireccion }),
},
    {
        ObtenerDireccionesCliente: true,
        query: true
    }, {
        add: true,
        update: true,
        delete: true
    });

addOnInvalidateHandler(DireccionCliente, () => invalidateResource(Cliente));



// WEBPACK FOOTER //
// ./app/resources/items/direccioncliente.ts